// Generated by `yarn tokens:import --aos-ds` from the Figma component "Modal/Header" (6907:2620). Do not edit.
//
// This component is composed rather than a variant matrix, so the contract
// carries the tokens its Figma node binds and the component is written by hand.
// The spec asserts the two agree exactly — see dsComposedModule in
// packages/aos-ui-universal/scripts/tokens-import.mjs for why.

export type ContractProp =
    | { kind: 'text' }
    | { kind: 'boolean' }
    | { kind: 'instance_swap' }
    // A slot is also a declared property, not only a node in the tree.
    | { kind: 'slot' }
    | { kind: 'variant'; values: readonly string[] }

export type TokenSubstitution = { was: string; now: string; value: number; why: string }

export type ContractComposition = { component: string; variants: readonly string[] }

/** `variable: null` is a removal: the main component binds it, this instance does not. */
export type InstanceOverride = {
    path: string
    property: string
    variable: string | null
    was: string | null
}

/** Where the caller puts content — `children`, or a prop per named slot. */
export type ContractSlot = { path: string; name: string }

export const modalHeaderContract = {
    component: 'Modal/Header',
    nodeId: '6907:2620',
    section: '[Web] Modals',
    textStyleIds: ['S:7128ca49edc77e1b4cfbcf2d61aa135d736752a2,'],
    figmaTokens: [
        'background/sub-surface',
        'border/subtle',
        'cards',
        'content/default',
        'large-layout/2xl',
        'medium-less-dense/l',
        'small-compact/s',
    ],
    // What the bound text style is made of. On record, not asserted against
    // classes: these reach the page as Typography's variant, not as a class.
    textTokens: ['family/family', 'line-height/h1', 'size/h1', 'weight/regular'] as string[],
    // Inherited from the components this one instantiates. Verified in their
    // own contracts, so drift.ts subtracts these rather than counting them here.
    childTokens: [] as string[],
    // Other components this one instantiates. The spec asserts every
    // variant named here still exists in that component's contract.
    composes: [{ component: 'Close', variants: [] }],
    overrides: [] as InstanceOverride[],
    // Where the caller puts content. A slot is the API, not the paint:
    // reading one as a plain frame keeps its padding and loses that
    // anything goes there at all.
    slots: [{ path: 'Modal/Header/1:slot', name: 'slot' }],
    props: {
        slot: { kind: 'slot' },
        title: { kind: 'text' },
    },
    substituted: [] as TokenSubstitution[],
} as const
